import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const LG_MIN_PX = 992;

function isLgViewport(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(`(min-width: ${LG_MIN_PX}px)`).matches;
}

export function useAuthenticatedSidebar(): {
  lgUp: boolean;
  desktopSidebarOpen: boolean;
  mobileNavOpen: boolean;
  handleNavToggle: () => void;
  setMobileNavOpen: Dispatch<SetStateAction<boolean>>;
} {
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [lgUp, setLgUp] = useState(() => isLgViewport());

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${LG_MIN_PX}px)`);
    const onChange = () => {
      const next = mq.matches;
      setLgUp(next);
      if (next) {
        setMobileNavOpen(false);
      }
    };
    mq.addEventListener('change', onChange);
    onChange();
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const handleNavToggle = () => {
    if (isLgViewport()) {
      setDesktopSidebarOpen((open) => !open);
    } else {
      setMobileNavOpen((open) => !open);
    }
  };

  return {
    lgUp,
    desktopSidebarOpen,
    mobileNavOpen,
    handleNavToggle,
    setMobileNavOpen,
  };
}
